import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/shadcn/lib/utils";

const notificationDotVariants = cva("rounded-full", {
  variants: {
    variant: {
      default: "bg-newTheme-ageless-primary",
      success: "bg-status-success",
      warning: "bg-status-warning",
      error: "bg-status-error",
    },
    size: {
      default: "h-2 w-2",
      sm: "h-1.5 w-1.5",
      lg: "h-3 w-3",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

export type NotificationDotProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof notificationDotVariants>;

export const NotificationDot = React.forwardRef<HTMLDivElement, NotificationDotProps>(
  ({ className, variant, size, ...props }, ref) => (
    <div
      className={cn(notificationDotVariants({ variant, size }), className)}
      ref={ref}
      {...props}
    />
  ),
);

NotificationDot.displayName = "NotificationDot";
